import { Component, Prop, Mixins } from 'vue-property-decorator';
import template from './canada-distributions-panel.vue'
import * as mws from '../../../shared/MwsViewModels';
import CanadaDistributionTable from './canada-distribution-table/CanadaDistributionTable'
import { Table } from '../../../shared/MwsViewModels';
import FadeTransitionMixin from '../../../shared/fade-transition/FadeTransitionMixin';

@Component({
  mixins: [template],
  components: {
    CanadaDistributionTable
  }
})
export default class CanadaDistributionsPanel extends Mixins(FadeTransitionMixin) {
  @Prop()
  data: mws.CanadaDistributionsPanel;

  currentTableIndex = 0;

  async onTabClick(index: number): Promise<void> {
    if (index === this.currentTableIndex) {
      return;
    }

    const tableList = this.$refs.tableList as HTMLElement;
    const currentlySelectedTable = tableList.children[this.currentTableIndex] as HTMLElement;
    const newSelectedTable = tableList.children[index] as HTMLElement;

    await this.fadeHide(currentlySelectedTable);
    this.currentTableIndex = index;
    await this.fadeShow(newSelectedTable);
  }
}
